import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-otp-input',
  standalone: true,
  imports: [CommonModule , FormsModule],
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss']
})
export class OtpInputComponent {
  @Input() length = 6;   // default OTP length
  @Output() completed = new EventEmitter<string>();

  otp: string[] = [];

  ngOnInit() {
    this.otp = new Array(this.length).fill('');
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace') {

      this.otp[index] = '';
      input.value = '';
      

      if (index > 0) {
        const prev = document.getElementById(`otp-${index - 1}`) as HTMLInputElement;
        prev.focus();
        prev.select();
      }
      event.preventDefault();
    }
  }

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();

    if (!/^\d$/.test(value)) {
      input.value = '';
      this.otp[index] = '';
      return;
    }

    this.otp[index] = value;

    if (index < this.length - 1) {
      setTimeout(() => {
        const next = document.getElementById(`otp-${index + 1}`) as HTMLInputElement;
        next.value = ""
        
        next.focus();
        next.select();
      });
    }
    
    this.emitOtpIfComplete();
  }

  private emitOtpIfComplete() {
    if (this.otp.every(x => x !== '')) {
      
      this.completed.emit(this.otp.join(''));
    }
  }
}
